module.exports = __webpack_public_path__ + "assets/lessons/pl/lesson6/modals/lesson_6_4_e.pdf";